export default {
  authData: {
    loginDetails: {},
    authenticated: false,
    error: ''
  },

  productData: {
    categoryList: [],
    productCategoryList: [],
    subCategoryList: [],
    cloneCategoryList: [],
    productList: [],
    createdProduct: "",
    updateProduct: {},
    productIngredients: [],
    updatedproductIngredients: {},
    productDetails: {},
    updateCategory: {},
    updateSubCategory: {},
    createdSubCategory: {}
  },

  offerData: {
    offerList: [],
    offerResponse: {}
  },

  orderData: {
    orderList: [],
    orderDetails: {},
    orderResponse: {},
    currentOrderDetails: {}
  },

  managerData: {
    managerResponse: {},
    managerList: [],
    managerDetails: {},
    profileResponse: {}
  },

  ingredientData: {
    ingredientList: [],
    ingredientReportList: [],
    updateIngredientData: {},
    addedIngredientDetails: {},
    resettedIngredientQty: {}
  },

  purchaseOrderData: {
    purchaseOrderList: [],
    newPO: {},
    poDetails: {},
    poMoveStatus: {},
    poCancelStatus: {},
    updatedPOData: {}
  },

  reports: {
    reportList: [],
  }
}